import {
    Channel,
    ChannelStyle,
    ChannelsFilterDtoIn,
    ChannelInfo,
    CopyChannel,
    AddEditChannelDto
} from "@/services/channels/types";
import api from "@/services/api";
import { AclMember } from "@/services/security/types";
export async function getFilteredChannels(model: ChannelsFilterDtoIn): Promise<Channel[]> {
    return new Promise((resolve, reject) => {
        api.post("/channels/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllChannels(): Promise<Channel[]> {
    return new Promise((resolve, reject) => {
        api.get("/channels").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFavorites(): Promise<Channel[]> {
    return new Promise((resolve, reject) => {
        api.get("/channels/favorite").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getRecent(): Promise<Channel[]> {
    return new Promise((resolve, reject) => {
        api.get("/channels/recent").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelById(id: string): Promise<Channel> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetChannelInfo(id: string): Promise<ChannelInfo> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelsByType(type: string): Promise<Array<Channel>> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/type/${type}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createChannel(channelDto: AddEditChannelDto): Promise<string> {
    return new Promise((resolve, reject) => {
        api.post("/channels", channelDto).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateChannel(channelDto: AddEditChannelDto): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/channels/", channelDto).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyChannel(channel: CopyChannel): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/channels/copy/", channel).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/delete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteChannel(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        api.delete(`/channels/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAlreadyUsedPostTypes(
    id: string
): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/usedPostTypes/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelStyle(id: string, type: string): Promise<ChannelStyle> {
    return new Promise((resolve, reject) => {
        api.get(`/channels/style/${id}/${type}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAcl(id: string): Promise<AclMember[]> {
    return new Promise((resolve, reject) => {
        api.get(`/acl/channel/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelResolutions(): Promise<string[]> {
    return new Promise((resolve, reject) => {
        api.get("/channels/resolutions").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
